import { AnyObject } from './basic';
import { getV1PageData } from './v1';
import { getV2PageData } from './v2';
import { getV3PageData } from './v3';
import { getV4PageData } from './v4';

export type IPageData = {
  product: any;
  type: number;
  ring_type: string;
  subpath: string;
  storeData: AnyObject | null;
  isBuildFromScratch?: boolean;
  showCollegiateBands?: boolean;
};

export const getPageData = (props: IPageData) => {
  const { type } = props;
  if(type === 1) {
    // for Men's wedding bands
    return getV1PageData(props);
} else if (type === 2) {
    // for Women's anniversary bands
    return getV2PageData(props);
} else if (type === 3) {
    // for Signet rings / Collegiate Signets
    return getV3PageData(props);
} else if (type === 4) {
    // for Collegiate Bands
    return getV4PageData(props);
}
  return [];
};
